<template>
  <v-container grid-list-lg fluid>
    <loading v-if="!bid && !errors" />

    <v-layout row wrap v-if="!bid && errors">
      <v-flex xs12 pt-5 mt-5 pb-5 mb-5>
        <h2 class="empty_title">
          <v-icon color="error">warning</v-icon>
          {{ errors }}
          <v-icon color="error">warning</v-icon>
        </h2>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="bid">
      <v-flex xs12>
        <h1>Заявка {{ user.full_name ? `от ${user.full_name}` : "" }}</h1>
        <v-flex xs12>
          <div class="font-weight-light">
            Телефон менеджера: {{ user.phone | formatPhone }}
          </div>
          <div class="font-weight-light">E-mail: {{ user.email }}</div>
        </v-flex>
      </v-flex>
      <v-flex xs12 py-0>
        <v-divider />
      </v-flex>
      <v-flex xs12 py-0>
        <v-container fluid>
          <v-flex xs12>
            <bid-info :bid="bid" :company="company"></bid-info>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="bid">
      <v-flex xs12>
        <v-layout row wrap client__data>
          <v-flex
            @click="getCompany"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'company',
            }"
          >
            <strong>Компания</strong>
          </v-flex>

          <v-flex
            v-if="isShowFinancial"
            @click="getFinances"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'finances',
            }"
          >
            <strong>Фин. показатели</strong>
          </v-flex>
          <v-flex
            @click="getDocuments"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'documents',
            }"
          >
            <strong>Документы и лицензии</strong>
          </v-flex>
          <v-flex
            @click="getFaces"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'faces',
            }"
          >
            <strong>Ответственные лица</strong>
          </v-flex>
          <v-flex
            @click="getBanks"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'bank',
            }"
          >
            <strong>Банковские реквизиты</strong>
          </v-flex>
          <v-flex
            @click="getBid"
            :class="{
              'client__data-tab pb-0': true,
              active: this.activeTab === 'bid',
            }"
          >
            <strong>Заявка</strong>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'company'">
          <v-flex xs12 pt-0>
            <loading v-if="!companyLoaded" />
            <div class="block grid-list-lg" v-else>
              <my-company
                :company-data="company"
                :bidStatus="bid.status"
                v-on:nextTab="nextTab"
                :editMode="true"
                :agentMode="inn"
                :publicHash="$route.query.hash"
                class="mt-3"
                v-if="company && !companyErrors"
              />
              <h2
                class="empty_title"
                v-if="companyErrors && companyErrors.length"
              >
                <v-icon color="error">warning</v-icon>
                Ошибка загрузки данных о компании: {{ companyErrors }}
              </h2>
            </div>

            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <!-- <v-btn @click="getBid" color="primary"  :loading="isNextPrevDisabled" :disabled="isNextPrevDisabled" class="mr-0"
                  >Назад</v-btn
                > -->
              </v-flex>
              <v-flex shrink>
                <v-btn
                  @click="onCompanyToFinance"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  color="primary"
                  class="mr-0"
                  >Далее</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'finances' && isShowFinancial">
          <v-flex xs12 pt-0>
            <loading v-if="!financesLoaded" />
            <div class="block" v-else>
              <finance
                :finance-data="finances"
                :editMode="true"
                :bidStatus="bid.status"
                :publicMode="$route.query.hash"
                :packageMode="false"
                :publicHash="$route.query.hash"
                v-if="finances && !financeErrors"
              />
              <h2
                class="empty_title"
                v-if="financeErrors && financeErrors.length"
              >
                <v-icon color="error">warning</v-icon>
                Ошибка загрузки фин. показателей: {{ financeErrors }}
              </h2>
            </div>
            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <v-btn
                  @click="getCompany"
                  color="primary"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  class="ml-0"
                  >Назад</v-btn
                >
              </v-flex>
              <v-flex shrink>
                <v-btn
                  @click="onFinanceToDocuments"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  color="primary"
                  class="mr-0"
                  >Далее</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'documents'">
          <v-flex xs12 pt-0>
            <loading v-if="!documentsLoaded" />
            <div class="block" v-else>
              <my-documents
                :documents-data="documents"
                :publicMode="$route.query.hash"
                :bidStatus="bid.status"
                v-on:updateDocuments="updateDocuments"
                v-if="documents && !documentsErrors"
              />
              <h2
                class="empty_title"
                v-if="documentsErrors && documentsErrors.length"
              >
                <v-icon color="error">warning</v-icon>
                Ошибка загрузки документов: {{ documentsErrors }}
              </h2>
            </div>
            <loading v-if="!licencesLoaded" />
            <div class="mt-3 pt-4" v-else>
              <licences
                :licences-data="licences"
                v-on:updateLicences="updateLicences"
                v-on:addLicence="addLicence"
                v-on:addLicenceFile="addLicence"
                :editMode="isPublicHashSave"
                :packageMode="true"
                :agentMode="inn"
                :publicHash="$route.query.hash"
                v-if="licences && !licencesErrors"
              />
              <h2
                class="empty_title"
                v-if="licencesErrors && licencesErrors.length"
              >
                <v-icon color="error">warning</v-icon>
                Ошибка загрузки лицензий: {{ licencesErrors }}
              </h2>
            </div>
            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <v-btn
                  @click="isShowFinancial ? getFinances() : getCompany()"
                  color="primary"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  class="ml-0"
                  >Назад</v-btn
                >
              </v-flex>
              <v-flex shrink>
                <v-btn
                  @click="getFaces"
                  color="primary"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  class="mr-0"
                  >Далее</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'faces'">
          <v-flex xs12 pt-0>
            <loading v-if="!facesLoaded" />
            <div v-else>
              <h2>Руководитель</h2>
              <faces
                :faces-data="faces"
                :packageMode="true"
                :agentMode="inn"
                :publicHash="$route.query.hash"
                v-on:updateFaces="updateFaces"
                v-on:updateFacesAndFounders="updateFacesAndFounders"
                :editMode="isPublicHashSave"
                v-if="faces && !facesErrors"
              />
              <h2 class="empty_title" v-if="facesErrors && facesErrors.length">
                <v-icon color="error">warning</v-icon>
                Ошибка загрузки руководителей: {{ facesErrors }}
              </h2>
            </div>

            <loading v-if="!ownersLoaded" />
            <div v-else class="mt-5">
              <h2>Собственники (учредитель)</h2>
              <owners
                :owners-data="owners"
                :packageMode="true"
                :agentMode="inn"
                :publicHash="$route.query.hash"
                v-on:updateOwners="updateOwners"
                :editMode="isPublicHashSave"
                v-if="owners && !ownersErrors"
              />
              <h2
                class="empty_title"
                v-if="ownersErrors && ownersErrors.length"
              >
                <v-icon color="error">warning</v-icon>
                Ошибка загрузки собственников: {{ ownersErrors }}
              </h2>
            </div>
            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <v-btn
                  @click="getDocuments"
                  color="primary"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  class="ml-0"
                  >Назад</v-btn
                >
              </v-flex>
              <v-flex shrink>
                <v-btn
                  @click="getBanks"
                  color="primary"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  class="mr-0"
                  >Далее</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'bank'">
          <v-flex xs12 pt-0>
            <loading v-if="!bankLoaded" />
            <div v-else>
              <legals
                :bank-data="bank"
                v-on:updateBanks="updateBanks"
                v-on:addBanks="addBanks"
                :editMode="isPublicHashSave"
                :packageMode="true"
                :agentMode="inn"
                :publicHash="$route.query.hash"
                v-if="bank && !bankErrors"
              />
              <h2 class="empty_title" v-if="bankErrors && bankErrors.length">
                <v-icon color="error">warning</v-icon>
                Ошибка загрузки банковских реквизитов: {{ bankErrors }}
              </h2>
            </div>
            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <v-btn
                  @click="getFaces"
                  color="primary"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  class="ml-0"
                  >Назад</v-btn
                >
              </v-flex>
              <v-flex shrink>
                <v-btn
                  @click="getBid"
                  color="primary"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  class="mr-0"
                  >Далее</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="activeTab === 'bid'">
          <v-flex xs12 pt-0>
            <div class="block">
              <loading v-if="!bidLoaded" />

              <bid
                :bid="bid"
                :company="company"
                :publicHash="$route.query.hash"
                v-on:refreshBid="refreshBid"
                v-if="bid && bidLoaded"
                hide-info
              />

              <h2 class="empty_title" v-if="bidErrors && bidErrors.length">
                <v-icon color="error">warning</v-icon>
                Ошибка загрузки заявок: {{ bidErrors }}
              </h2>
            </div>
            <v-layout row wrap justify-space-between py-4>
              <v-flex shrink>
                <v-btn
                  @click="getBanks"
                  color="primary"
                  class="ml-0"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  >Назад</v-btn
                >
              </v-flex>
              <v-flex shrink>
                <v-btn
                  v-if="isPublicHashSave"
                  @click="onCompleteAndSendBid"
                  color="green"
                  class="ml-0 white--text"
                  :loading="isNextPrevDisabled"
                  :disabled="isNextPrevDisabled"
                  >Завершить</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import Bid from "@/components/bids/bid";
import BidInfo from "@/components/bids/info";
import MyCompany from "@/components/clients/company";
import MyDocuments from "@/components/clients/documents";
import Licences from "@/components/clients/licences";
import Faces from "@/components/clients/faces";
import Owners from "@/components/clients/owners";
import Legals from "@/components/clients/bank";
import Finance from "@/components/clients/finance";
import formatPhone from "@/mixins/filters/formatPhone";
import showNotify from "@/services/noty";

export default {
  name: "PublicBid",
  mixins: [formatPhone],
  data: () => ({
    errors: null,
    id: "",
    client: "",
    bids: null,
    bidLoaded: false,
    bidsErrors: null,
    company: null,
    companyLoaded: false,
    documents: null,
    documentsLoaded: false,
    licences: null,
    licencesLoaded: false,
    owners: null,
    ownersLoaded: false,
    faces: null,
    facesLoaded: false,
    bank: null,
    bankLoaded: false,
    finances: null,
    financesLoaded: false,
    activeTab: "bid",
    //
    user: null,
    inn: null,
    bid: null,
    bidErrors: null,
    bidServiceType: "",
    companyErrors: null,
    ownersErrors: null,
    facesErrors: null,
    bankErrors: null,
    documentsErrors: null,
    licencesErrors: null,
    finance: null,
    financeErrors: null,
    isLoaded: false,

    isNextPrevDisabled: false,
  }),
  computed: {
    isPublicHashSave() {
      if (this.bid.status == 0) return true;
      if (this.bid.status == 30) return true;
      return false;
    },

    //Скрываем show Financial
    isShowFinancial(){
      return false;
    },
  },
  methods: {
    onCompanyToFinance() {
      if (!this.isPublicHashSave) {
        window.scrollTo(0, 0);
        if(this.isShowFinancial){
          this.getFinances();
        } else {
          this.getDocuments();
        }
        
      } else {
        this.isNextPrevDisabled = true;
        this.$root.$off("onNextCompany");
        let buttonSave = document.getElementById("companySaveButton");
        this.$root.$on("onNextCompany", (valid) => {
          if (valid === true) {
            window.scrollTo(0, 0);
            if(this.isShowFinancial){
               this.getFinances();
            } else {
              this.getDocuments();
            }
           
          } else {
            showNotify("error", "Заполните все поля правильно");
          }
          this.$root.$off("onNextCompany");
          this.isNextPrevDisabled = false;
        });
        buttonSave.click();
      }
    },

    //onCompanyToDocuments
    onFinanceToDocuments() {
      if (!this.isPublicHashSave) {
        window.scrollTo(0, 0);
        this.getDocuments();
      } else {
        this.isNextPrevDisabled = true;
        this.$root.$off("onNextFinance");
        let buttonSave = document.getElementById("financeSaveButton");
        this.$root.$on("onNextFinance", (valid) => {
          if (valid === true) {
            window.scrollTo(0, 0);
            this.getDocuments();
          } else {
            showNotify("error", "Заполните все поля правильно");
          }
          this.$root.$off("onNextFinance");
          this.isNextPrevDisabled = false;
        });
        buttonSave.click();
      }
    },

    onCompleteAndSendBid() {
      this.isNextPrevDisabled = true;
      this.$root.$off("onSendBid");
      let buttonSave = document.getElementById("sendBidButton");
      if (buttonSave.classList.contains("v-btn--disabled")) {
        showNotify("error", "Заполните все поля правильно");
        this.isNextPrevDisabled = false;
      } else {
        this.$root.$on("onSendBid", (valid) => {
          if (valid === true) {
            window.scrollTo(0, 0);
            this.getDocuments();
          } else {
            showNotify("error", "Заполните все поля правильно");
          }
          this.$root.$off("onSendBid");
          this.isNextPrevDisabled = false;
        });
        buttonSave.click();
      }
    },

    async getCompany() {
      this.companyErrors = null;
      this.company = null;
      this.activeTab = "company";

      const { hash } = this.$route.query;
      const url = `v1/company/get-by-public-hash/${hash}`;
      const params = { inn: this.inn };

      await apiCallTrue({
        url,
        params,
      })
        .then((response) => {
          this.company = response.data.data;
          this.companyLoaded = true;
        })
        .catch((error) => {
          this.companyErrors = error.message;
        });
    },
    async getBid(isFirst = false) {
      this.bidLoaded = false;
      this.activeTab = "bid";
      this.errors = null;

      const { hash } = this.$route.query;
      const url = `v1/temporary/client-data/${hash}`;
      const params = { inn: this.inn };

      await apiCallTrue({
        url,
        params,
      })
        .then((response) => {
          this.bid = response.data.data;
          if (!this.bidServiceType) {
            if (this.bid.type === 5 || this.bid.type === 7) {
              this.bidServiceType = "bankKik";
            } else {
              this.bidServiceType = "bankGuarantee";
            }
            this.inn = this.bid.user_inn;
            this.user = this.bid.user;

            if (this.userRole === 10) {
              this.fillTodos();
            }
            if (
              this.userRole === 30 &&
              this.bid.agentClient &&
              this.bid.agentClient.length
            ) {
              this.company = {};
              this.company.data = this.bid.agentClient;
            }
            if (
              this.bid.status !== 0 &&
              response &&
              response.data &&
              response.data.data &&
              response.data.data.package
            ) {
              this.company = this.bid.package.clientCompany;
              this.bank = this.bid.package.bankAccounts;
              this.finance = this.bid.package.financials;
              this.founders = this.bid.package.founders;
              this.officials = this.bid.package.officials;
              this.documents = this.bid.package.documents;
              this.licences = this.bid.package.licenses;
            }

            if (response.data.data.package[this.bidServiceType].date_from) {
              this.deFormatDateFrom();
            }

            if (response.data.data.package[this.bidServiceType].date_to) {
              this.deFormatDateTo();
            }

            if (response.data.data.package[this.bidServiceType].date_from) {
              this.deFormatIssueDeadlineDate();
            }

            this.getDateRange();

            if (this.userRole === 10) {
              this.setTodos();
            }

            if (this.bid.status < 50) {
              this.isBidDataOpen = [true];
            }

            // for (let key in this.bid.package.children) {
            //     console.log(
            //         key +
            //             " - " +
            //             this.bid.package.children[key].bank.name
            //     );
            // }

            if (
              !this.bid &&
              !this.bid.package &&
              !this.bid.package.children &&
              !this.bid.package.children.length
            ) {
              this.getNewBanks();
            }
          }

          this.bidLoaded = true;
          if (isFirst === true) {
            this.getCompany();
          }
        })
        .catch((error) => {
          this.errors = error.message;
          this.bidLoaded = true;
        });
    },
    async getOwners() {
      this.ownersErrors = null;
      const { hash } = this.$route.query;
      const url = `v1/founders/get-by-public-hash/${hash}`;
      const params = { inn: this.inn };

      await apiCallTrue({
        url,
        params,
      })
        .then((response) => {
          this.owners = response.data.data || [];
          this.ownersLoaded = true;
        })
        .catch((error) => {
          this.ownersErrors = error.message;
        });
    },

    async getFaces() {
      this.activeTab = "faces";
      this.facesErrors = null;
      const { hash } = this.$route.query;
      const url = `v1/officials/get-by-public-hash/${hash}`;
      const params = { inn: this.inn };

      await apiCallTrue({
        url,
        params,
      })
        .then((response) => {
          this.getOwners();
          this.faces = response.data.data || [];
          this.facesLoaded = true;
        })
        .catch((error) => {
          this.facesErrors = error.message;
        });
    },

    async getBanks() {
      this.activeTab = "bank";
      this.bankErrors = null;
      const { hash } = this.$route.query;
      const url = `v1/bank-accounts/get-by-public-hash/${hash}`;
      const params = { inn: this.inn };

      await apiCallTrue({
        url,
        params,
      })
        .then((response) => {
          this.bank = response.data.data || [];
          this.bankLoaded = true;
        })
        .catch((error) => {
          this.bankErrors = error.message;
        });
    },
    async getDocuments() {
      this.documentsLoaded = false;
      this.activeTab = "documents";
      this.documentsErrors = null;
      const { hash } = this.$route.query;
      const url = `v1/folders/get-by-public-hash/${hash}`;
      const params = { inn: this.inn, type: 0 };

      await apiCallTrue({
        url,
        params,
      })
        .then((response) => {
          this.documents = response.data.data.folders;
          this.getLicences();
          this.documentsLoaded = true;
        })
        .catch((error) => {
          this.documentsErrors = error.message;
          console.log(error, "docs error");
        });
    },

    async getLicences() {
      this.licencesLoaded = false;
      this.licencesErrors = null;
      const { hash } = this.$route.query;
      const url = `v1/licenses/get-by-public-hash/${hash}`;
      const params = { inn: this.inn };

      await apiCallTrue({
        url,
        params,
      })
        .then((response) => {
          this.licences = response.data.data || [];
          this.licencesLoaded = true;
        })
        .catch((error) => {
          this.licencesErrors = error.message;
        });
    },
    async getFinances() {
      this.financesLoaded = false;
      this.activeTab = "finances";
      this.financeErrors = null;

      const { hash } = this.$route.query;
      const url = `v1/financials/get-by-public-hash/${hash}`;
      const params = { inn: this.inn };

      await apiCallTrue({
        url,
        params,
      })
        .then((response) => {
          this.finances = response.data.data;
          this.financesLoaded = true;
        })
        .catch((error) => {
          this.financeErrors = error.message;
          this.financesLoaded = true;
        });
    },
    nextTab() {
      return this.activeTab++;
    },
    updateFaces() {
      this.getFaces();
    },
    updateBanks(updatedBank) {
      this.bank.map((bank) => {
        if (bank.id === updatedBank.id) {
          Object.assign(bank, updatedBank);
        }
      });
    },
    addBanks(bank) {
      this.bank.push(bank);
    },

    updateFacesAndFounders() {
      this.getFaces();
      this.getOwners();
    },
    updateOwners() {
      this.getOwners();
    },
    updateDocuments() {
      this.getDocuments();
    },
    updateLicences(licence) {
      this.licences.map((item) => {
        if (item.id === licence.id) {
          Object.assign(item, licence);
        }
      });
    },
    addLicence(licence) {
      this.licences.push(licence);
    },
    refreshBid() {
      this.getBid();
    },
    getDateRange() {
      if (
        this.bid.package[this.bidServiceType].date_from &&
        this.bid.package[this.bidServiceType].date_to
      ) {
        const dateFrom = new Date(
          this.bid.package[this.bidServiceType].date_from
        );
        const dateTo = new Date(this.bid.package[this.bidServiceType].date_to);

        const serviceRange = Math.ceil(
          Math.abs(dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24)
        );

        this.serviceRange = Number.isNaN(serviceRange) ? "-" : serviceRange;
      }
      return "-";
    },
  },
  mounted() {
    this.getBid(true);
    this.$root.$on("changeClientTab", (obj) => {
      switch (obj.key) {
        case "company":
          {
            this.getCompany();
          }
          break;

        case "founders":
        case "officials":
          {
            this.getFaces();
          }
          break;

        case "bank-accounts":
          {
            this.getBanks();
          }
          break;

        case "documents":
          {
            this.getDocuments();
          }
          break;

        case "financials":
          {
            this.getFinances();
          }
          break;
      }
      console.log("changeClientTab", obj);
    });
  },
  beforeDestroy() {
    this.$root.$off("changeClientTab");
  },
  components: {
    Bid,
    BidInfo,
    MyCompany,
    MyDocuments,
    Licences,
    Faces,
    Owners,
    Legals,
    Finance,
  },
};
</script>
<style lang="scss">
.client {
  &__data {
    &-tab {
      strong {
        display: inline-flex;
        border-bottom: 2px solid transparent;
        padding: 4px 8px 12px;
        color: #666;
        font-size: 12px;
        text-transform: uppercase;
        cursor: pointer;
      }
      &.active {
        strong {
          border-bottom-color: #404ce6;
          color: #000;
        }
      }
    }
  }
}
</style>